import { currentDefaultVersion } from "@/assets/mobiusVersioningData";
import { useAuthStore } from "@/stores/authStore";
import type { MobiusTenant } from "@/types";

const STAGING_BASE_URL = `https://${import.meta.env.VITE_APP_MOBIUS_STAGE_HOST}`;

function isLocalDev(): boolean {
  return window.location.hostname === "localhost";
}

function getVersionedUrl(versionTag: string, path: string = "/"): string {
  const base = isLocalDev() ? STAGING_BASE_URL : window.location.origin;
  return `${base}/${versionTag}${path}`;
}

export function redirectIfVersionMismatch(tenant: MobiusTenant, targetPath?: string): boolean {
  if (!tenant.version_tag) return false;
  if (tenant.version_tag === currentDefaultVersion) return false;

  if (isLocalDev()) {
    const { authClient } = useAuthStore();
    authClient.removeUser();
  }

  const path = targetPath ?? "/";
  const redirectUrl = new URL(getVersionedUrl(tenant.version_tag, path));
  redirectUrl.searchParams.set("tenantId", String(tenant.id));
  window.location.href = redirectUrl.toString();
  return true;
}
